export default {"src":"/_next/static/media/filterFunnelDisabled.d6964ea3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};